import { useLocation } from "react-router-dom";

export const Footer = () => {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return (
      <footer
        className="px-6 md:px-12 pt-6 pb-8 flex justify-end"
        data-testid="site-footer"
      >
        <span
          className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#504439]"
          data-testid="footer-rights"
        >
          All Rights Reserved
        </span>
      </footer>
    );
  }

  return (
    <footer
      className="relative px-6 md:px-12 pt-12 pb-10 flex flex-col items-center gap-8 md:block"
      data-testid="site-footer"
    >
      <div className="flex justify-center">
        <img
          src="/trona-pictogram.webp"
          alt="TRONA"
          className="h-24 md:h-32 w-auto"
          data-testid="footer-logo"
        />
      </div>
      <span
        className="md:absolute md:right-12 md:bottom-10 font-mono text-[10px] tracking-[0.2em] uppercase text-[#504439]"
        data-testid="footer-rights"
      >
        All Rights Reserved
      </span>
    </footer>
  );
};
